import { Alert, Typography } from "antd"
const { Text } = Typography;
const TaxReduceSuggestion: React.FC<{ isAllTaxReduce: boolean | null }> = (props) => {

    return props.isAllTaxReduce === null ? <></> : (<Alert
        type={props.isAllTaxReduce ? "success" : "warning"}
        message="GỢI Ý THAM KHẢO KHÔNG HOÀN TOÀN CHÍNH XÁC"
        showIcon={true}
        description={(
            props.isAllTaxReduce === true
                ?
                (<Text>Chương trình Không tìm thấy mặt hàng này trong Danh mục hàng hóa, dịch vụ không được giảm thuế GTGT theo phụ lục I, II, III kèm theo Nghị định 44/2023/NĐ-CP.
                    <br />Mặt hàng này <Text type="success" strong={true}>có thể thuộc đối tượng áp dụng giảm thuế GTGT</Text>, vui lòng kiểm tra lại thông tin giảm thuế của mặt hàng.
                </Text>)
                :
                (<Text>
                    Chương trình tìm thấy một số kết quả của mặt hàng này trong Danh mục hàng hóa, dịch vụ KHÔNG ĐƯỢC GIẢM thuế GTGT theo phụ lục I, II, III kèm theo Nghị định 44/2023/NĐ-CP.
                    <br />Mặt hàng này <Text type="warning" strong={true}>có thể thuộc đối tượng không được giảm thuế GTGT</Text>, vui lòng kiểm tra lại thông tin giảm thuế của mặt hàng.
                </Text>)
        )}
    />)
}
export default TaxReduceSuggestion;